import React, { createContext, useContext } from 'react'
import { useJsApiLoader } from '@react-google-maps/api'

const GoogleMapsContext = createContext({ isLoaded: false, loadError: null })

export function GoogleMapsProvider({ children }) {
    const { isLoaded, loadError } = useJsApiLoader({
        id: 'ee-providers-map',
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
        libraries: ['places', 'drawing'],
        version: '3.64'
    })
    return (
        <GoogleMapsContext.Provider value={{ isLoaded, loadError }}>
            {children}
        </GoogleMapsContext.Provider>
    )
}

export function useGoogleMaps() {
    return useContext(GoogleMapsContext)
}
